import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import SideBar from '~addListing/components/SideBar';
import VerifyPhoneNumberBanner from '~addListing/components/VerifyPhoneNumberBanner';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import Loader from '~/components/Loader';
import useReverseScroll from '~/hooks/useReverseScroll';
import Wootric from '~/components/Wootric';

const Layout = () => {
  const { data, isSuccess, isLoading } = useGetUserQuery();
  const userIsVerified =
    data?.user?.is_phone_verified || data?.user?.has_subscription_plan;
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  useReverseScroll();

  useEffect(() => {
    if (locale) document.title = t('addListingPageTitle');
  }, [locale]);

  if (isLoading) return <Loader />;
  if (!isSuccess) {
    const locale = location.pathname.split('/')[1];
    window.location.replace(
      `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.LOGIN}`,
    );
  }

  return (
    <div className="layout-boundary flex-1 pt-4x pb-[40px] md:pb-[80px]">
      <div className="layout-boundary__inner px-2x md:px-0">
        <div className="flex flex-col md:flex-row gap-2x md:gap-[84px]">
          {!userIsVerified && <VerifyPhoneNumberBanner />}
          <SideBar />
          <Outlet />
        </div>
      </div>
      <Wootric locale={locale} />
    </div>
  );
};

export default Layout;
